export default "__VITE_ASSET__BjYGg2Hy__"